import { getMediaUrl } from 'utils/assets.ts';
import { Translation } from 'utils/translations';

import styles from './EmptyState.module.scss';

const TransactionsEmptyState = () => {
  return (
    <div className={styles['empty-state-container']}>
      <img
        src={getMediaUrl('/yellow/empty-box.webp')}
        alt="empty state"
        className={styles['empty-state-image']}
      />
      <p className={styles['empty-state-text']}>
        <Translation message="transactions_empty_description" />
      </p>
    </div>
  );
};

export default TransactionsEmptyState;
